import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, useLocation, Navigate } from 'react-router-dom';
import Pericia from './pages/Pericia';
import MercadoLivre from './pages/MercadoLivre';
import About from './pages/About';
import Husqvarna from './pages/husqvarna'; // Importa a nova página Husqvarna
import Treinamento from './pages/treinamento';
import Services from './pages/services';

// Registra o plugin ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// Componente Navbar
function Navbar() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavLinkClick = (page) => {
        setIsMobileMenuOpen(false);

        // Navega para páginas distintas
        if (page === 'about') {
            navigate('/about');
            return;
        }

        // Se já estiver na página inicial, apenas rola a tela
        if (location.pathname === '/') {
            if (page === 'inicio') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                document.getElementById(page)?.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            // Se estiver em outra página, navega para a inicial e passa o ID da seção para rolar
            navigate('/', { state: { scrollTo: page } });
        }
    };

    return (
        <header className="bg-husqvarna-dark-gray text-husqvarna-white shadow-lg fixed w-full z-50">
            <nav className="container mx-auto px-4 py-4 flex justify-between items-center">
                {/* Logo */}
                <button
                    type="button"
                    className="flex items-center space-x-2 bg-transparent border-none outline-none cursor-pointer"
                    onClick={() => handleNavLinkClick('inicio')}
                >
                    <img src="https://placehold.co/60x40/ff6600/ffffff?text=3E" alt="Logo 3E Máquinas" className="rounded-md" />
                    <span className="text-xl font-bold">Máquinas</span>
                </button>

                {/* Menu para Desktop */}
                <ul className={`hidden md:flex space-x-6 ${isMobileMenuOpen ? 'pointer-events-none opacity-50' : ''}`}>
                    <li>
                        <button type="button" className="hover:text-husqvarna-orange transition-colors duration-300 bg-transparent border-none outline-none cursor-pointer" onClick={() => handleNavLinkClick('inicio')}>Início</button>
                    </li>
                    <li>
                        <button type="button" className="hover:text-husqvarna-orange transition-colors duration-300 bg-transparent border-none outline-none cursor-pointer" onClick={() => handleNavLinkClick('about')}>Sobre a 3E</button>
                    </li>
                    <li>
                        <button type="button" className="hover:text-husqvarna-orange transition-colors duration-300 bg-transparent border-none outline-none cursor-pointer" onClick={() => handleNavLinkClick('mercado-livre-section')}>Loja Online</button>
                    </li>
                    <li>
                        <button type="button" className="hover:text-husqvarna-orange transition-colors duration-300 bg-transparent border-none outline-none cursor-pointer" onClick={() => handleNavLinkClick('servicos')}>Serviços</button>
                    </li>
                    <li>
                        <Link to="/treinamento" className="hover:text-husqvarna-orange transition-colors duration-300 bg-transparent border-none outline-none cursor-pointer text-inherit">Treinamento</Link>
                    </li>
                    <li>
                        <Link to="/husqvarna" className="hover:text-husqvarna-orange transition-colors duration-300 bg-transparent border-none outline-none cursor-pointer text-inherit">Husqvarna</Link>
                    </li>
                    <li>
                        <button type="button" className="hover:text-husqvarna-orange transition-colors duration-300 bg-transparent border-none outline-none cursor-pointer" onClick={() => handleNavLinkClick('contato')}>Contato</button>
                    </li>
                </ul>

                {/* Botão Hamburguer para Mobile */}
                <button id="menu-toggle" className="md:hidden text-husqvarna-white focus:outline-none" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                    <i className="fas fa-bars text-2xl"></i>
                </button>
            </nav>

            {/* Menu Mobile */}
            <div id="mobile-menu" className={`${isMobileMenuOpen ? 'block' : 'hidden'} md:hidden bg-husqvarna-dark-gray py-2`}>
                <ul className="flex flex-col items-center space-y-2">
                    <li>
                        <button type="button" className="block py-2 px-4 hover:bg-husqvarna-orange rounded-md transition-colors duration-300 w-full text-center bg-transparent border-none outline-none cursor-pointer" onClick={() => handleNavLinkClick('inicio')}>Início</button>
                    </li>
                    <li>
                        <button type="button" className="block py-2 px-4 hover:bg-husqvarna-orange rounded-md transition-colors duration-300 w-full text-center bg-transparent border-none outline-none cursor-pointer" onClick={() => handleNavLinkClick('about')}>Sobre a 3E</button>
                    </li>
                    <li>
                        <button type="button" className="block py-2 px-4 hover:bg-husqvarna-orange rounded-md transition-colors duration-300 w-full text-center bg-transparent border-none outline-none cursor-pointer" onClick={() => handleNavLinkClick('mercado-livre-section')}>Loja Online</button>
                    </li>
                    <li>
                        <button type="button" className="block py-2 px-4 hover:bg-husqvarna-orange rounded-md transition-colors duration-300 w-full text-center bg-transparent border-none outline-none cursor-pointer" onClick={() => handleNavLinkClick('servicos')}>Serviços</button>
                    </li>
                    <li>
                        <Link to="/treinamento" className="block py-2 px-4 hover:bg-husqvarna-orange rounded-md transition-colors duration-300 w-full text-center bg-transparent border-none outline-none cursor-pointer text-inherit">Treinamento</Link>
                    </li>
                    <li>
                        <Link to="/husqvarna" className="block py-2 px-4 hover:bg-husqvarna-orange rounded-md transition-colors duration-300 w-full text-center bg-transparent border-none outline-none cursor-pointer text-inherit">Husqvarna</Link>
                    </li>
                    <li>
                        <button type="button" className="block py-2 px-4 hover:bg-husqvarna-orange rounded-md transition-colors duration-300 w-full text-center bg-transparent border-none outline-none cursor-pointer" onClick={() => handleNavLinkClick('contato')}>Contato</button>
                    </li>
                </ul>
            </div>
        </header>
    );
};

// Componente Hero Section
const HeroSection = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        if (sectionRef.current) {
            gsap.fromTo(sectionRef.current.querySelectorAll('.animate-fade-in-up'),
                { opacity: 0, y: 50 },
                { opacity: 1, y: 0, duration: 1, stagger: 0.2, ease: "power3.out" }
            );
        }
    }, []);

    const handleHeroButtonClick = () => {
        document.getElementById('husqvarna')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section
            ref={sectionRef}
            id="inicio"
            className="relative bg-cover bg-center h-screen flex items-center justify-center text-center text-white pt-16"
            style={{ backgroundImage: "url('/images/trmower.jpeg')" }}
        >
            <div className="absolute inset-0 bg-black opacity-50"></div>
            <div className="relative z-10 p-8 rounded-lg max-w-3xl mx-auto">
                <h1 className="text-4xl md:text-6xl font-bold mb-4 animate-fade-in-up">Reduzindo a Pegada de Carbono com Husqvarna a Bateria e AutoMower 🌱</h1>
                <p className="text-lg md:text-xl mb-8 animate-fade-in-up">Tecnologia, Sustentabilidade e Eficiência para o seu Jardim.</p>
                <button
                    onClick={handleHeroButtonClick}
                    className="bg-husqvarna-orange text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-orange-700 transition-colors duration-300 animate-fade-in-up shadow-lg"
                >
                    Conheça Nossos Produtos Sustentáveis
                </button>
            </div>
        </section>
    );
};

// Componente Serviços
const ServicesSection = () => {
    const sectionRef = useRef(null);
    const [bgImage, setBgImage] = useState('');

    useEffect(() => {
        if (sectionRef.current) {
            gsap.utils.toArray(sectionRef.current.querySelectorAll('.service-card')).forEach((element, i) => {
                gsap.fromTo(element,
                    { opacity: 0, y: 50 },
                    {
                        opacity: 1, y: 0, duration: 0.8, delay: i * 0.1, ease: "power2.out",
                        scrollTrigger: {
                            trigger: element,
                            start: "top 90%",
                            toggleActions: "play none none none"
                        }
                    }
                );
            });
        }
    }, []);

    return (
        <section
            ref={sectionRef}
            id="servicos"
            className="py-16"
        >
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold text-center mb-12 text-husqvarna-dark-gray animate-fade-in-up">Nossos Serviços</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Card de Serviços - Cursos */}
                    <Link
                        to="/treinamento"
                        className="bg-white p-8 rounded-lg shadow-lg text-center service-card flex flex-col justify-center items-center hover:bg-husqvarna-light-gray transition cursor-pointer"
                        style={{ minHeight: 0 }}
                    >
                        <div className="text-husqvarna-orange text-5xl mb-4">
                            <i className="fas fa-graduation-cap"></i>
                        </div>
                        <h3 className="text-2xl font-semibold mb-4 text-husqvarna-dark-gray">
                            Cursos e Treinamentos
                        </h3>
                        <p className="text-lg leading-relaxed mb-4">
                            Oferecemos cursos especializados para o manuseio e manutenção de equipamentos, garantindo que você aproveite ao máximo sua máquina.
                        </p>
                        <span className="inline-block bg-husqvarna-orange text-white text-sm px-4 py-2 rounded-full font-semibold shadow mt-2">
                            Saiba mais
                        </span>
                    </Link>
                    {/* Card de Serviços - Perícias */}
                    <Link to="/pericia" className="bg-white p-8 rounded-lg shadow-lg text-center service-card flex flex-col justify-center items-center hover:bg-husqvarna-light-gray transition cursor-pointer">
                        <div className="text-husqvarna-orange text-5xl mb-4"><i className="fas fa-gavel"></i></div>
                        <h3 className="text-2xl font-semibold mb-4 text-husqvarna-dark-gray">Perícias Técnicas</h3>
                        <p className="text-lg leading-relaxed">Realizamos perícias técnicas precisas e imparciais, fornecendo laudos detalhados para diversas necessidades.</p>
                        <span className="inline-block bg-husqvarna-orange text-white text-sm px-4 py-2 rounded-full font-semibold shadow mt-2">
                            Saiba mais
                        </span>
                    </Link>
                    {/* Card de Serviços - Serviços Técnicos */}
                    <Link
                        to="/services"
                        className="bg-white p-8 rounded-lg shadow-lg text-center service-card flex flex-col justify-center items-center hover:bg-husqvarna-light-gray transition cursor-pointer"
                    >
                        <div className="text-husqvarna-orange text-5xl mb-4"><i className="fas fa-tools"></i></div>
                        <h3 className="text-2xl font-semibold mb-4 text-husqvarna-dark-gray">Serviços Técnicos e Manutenção</h3>
                        <p className="text-lg leading-relaxed mb-4">Contamos com uma equipe qualificada para assistência técnica e manutenção preventiva e corretiva de suas máquinas.</p>
                        <span className="inline-block bg-husqvarna-orange text-white text-sm px-4 py-2 rounded-full font-semibold shadow mt-2">
                            Saiba mais
                        </span>
                    </Link>
                </div>
            </div>
        </section>
    );
};

// Componente Seção Mercado Livre
const MercadoLivreSection = () => {
    const navigate = useNavigate();
    return (
        <section id="mercado-livre-section" className="py-16 bg-yellow-400">
            <div className="container mx-auto px-4 text-center">
                <img 
                    src="https://http2.mlstatic.com/frontend-assets/ml-web-navigation/ui-navigation/5.21.2/mercadolibre/logo__large_plus.png" 
                    alt="Logo Mercado Livre" 
                    className="h-12 md:h-16 mx-auto mb-4"
                />
                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Compre Online na Nossa Loja Oficial</h2>
                <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-8">
                    Visite nossa loja no Mercado Livre para encontrar uma vasta gama de produtos Husqvarna com a conveniência e segurança que você já conhece.
                </p>
                <button
                    onClick={() => navigate('/mercado-livre')}
                    className="bg-blue-500 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-blue-600 transition-colors duration-300 shadow-md"
                >
                    Visitar Loja Agora
                </button>
            </div>
        </section>
    );
};


// Componente Husqvarna Products
const HusqvarnaProducts = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        if (sectionRef.current) {
            gsap.fromTo(sectionRef.current.querySelector('.husqvarna-intro-left'),
                { opacity: 0, x: -50 },
                {
                    opacity: 1, x: 0, duration: 1, ease: "power3.out",
                    scrollTrigger: {
                        trigger: sectionRef.current,
                        start: "top 80%",
                        toggleActions: "play none none none"
                    }
                }
            );
            gsap.fromTo(sectionRef.current.querySelector('.husqvarna-intro-right'),
                { opacity: 0, x: 50 },
                {
                    opacity: 1, x: 0, duration: 1, ease: "power3.out",
                    scrollTrigger: {
                        trigger: sectionRef.current,
                        start: "top 80%",
                        toggleActions: "play none none none"
                    }
                }
            );
            gsap.utils.toArray(sectionRef.current.querySelectorAll('.product-card')).forEach((element, i) => {
                gsap.fromTo(element,
                    { opacity: 0, y: 50 },
                    {
                        opacity: 1, y: 0, duration: 0.8, delay: i * 0.1, ease: "power2.out",
                        scrollTrigger: {
                            trigger: element,
                            start: "top 90%",
                            toggleActions: "play none none none"
                        }
                    }
                );
            });
        }
    }, []);

    const navigate = useNavigate();

    return (
        <section ref={sectionRef} id="husqvarna" className="py-16 bg-husqvarna-light-gray">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold text-center mb-12 text-husqvarna-dark-gray animate-fade-in-up">Husqvarna: Inovação e Sustentabilidade</h2>
                <div className="flex flex-col md:flex-row items-center md:space-x-8 mb-12">
                    <div className="md:w-1/2 mb-8 md:mb-0 husqvarna-intro-left">
                        <img src="/images/automoweram550.png" alt="Husqvarna AutoMower AM550 em Ação" className="rounded-lg shadow-lg w-full h-auto object-cover" />
                        {/* Botão Saiba mais */}
                        <div className="flex justify-center mt-6">
                            <button
                                onClick={() => navigate('/husqvarna')}
                                className="bg-husqvarna-orange text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-orange-700 transition-colors duration-300 shadow-lg"
                            >
                                Saiba mais
                            </button>
                        </div>
                    </div>
                    <div className="md:w-1/2 husqvarna-intro-right">
                        <h3 className="text-3xl font-semibold mb-4 text-husqvarna-dark-gray">A Revolução da Jardinagem a Bateria e AutoMower</h3>
                        <p className="text-lg leading-relaxed mb-4">
                            A Husqvarna é líder mundial em equipamentos para manejo de áreas verdes, e na 3E Máquinas, destacamos as linhas a bateria e os revolucionários robôs cortadores AutoMower.
                        </p>
                        <p className="text-lg leading-relaxed mb-4">
                            Esses produtos representam o futuro da jardinagem: <strong className="text-husqvarna-orange">zero emissões diretas</strong>, <strong className="text-husqvarna-orange">baixo ruído</strong>, <strong className="text-husqvarna-orange">alta eficiência</strong> e <strong className="text-husqvarna-orange">manutenção simplificada</strong>. Com o AutoMower, seu gramado estará sempre impecável, sem esforço e com total respeito ao meio ambiente.
                        </p>
                        <p className="text-lg leading-relaxed">
                            Invista em tecnologia que cuida do seu jardim e do planeta.
                        </p>
                    </div>
                </div>

                <h3 className="text-3xl font-semibold text-center mb-8 text-husqvarna-dark-gray animate-fade-in-up">Nossos Produtos em Destaque</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {/* Produto 1 */}
                    <a
                        href="https://produto.mercadolivre.com.br/MLB-5482311282-automower-rob-cortador-de-grama-305-_JM?pdp_filters=seller_id%3A53613158#polycard_client=search-nordic&position=7&search_layout=grid&type=item&tracking_id=542d2cc3-6854-4132-ac00-d9820207cd35&wid=MLB5482311282&sid=search"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white p-6 rounded-lg shadow-lg text-center product-card hover:bg-husqvarna-light-gray transition cursor-pointer block"
                    >
                        <img src="/images/produtos/Automower305/MOWER4.jpg" alt="Husqvarna AutoMower 305" className="w-full h-48 object-contain mb-4 rounded-md" />
                        <h4 className="text-xl font-semibold mb-2 text-husqvarna-dark-gray">Husqvarna AutoMower 305</h4>
                        <p className="text-md text-gray-600 mb-4">Robô cortador de grama inteligente para grandes áreas.</p>
                        <span className="inline-block bg-green-500 text-white text-sm px-3 py-1 rounded-full">Sustentável</span>
                    </a>
                    {/* Produto 2 */}
                    <a
                        href="https://www.mercadolivre.com.br/motosserra-eletrica-husqvarna-535ixp-bateria-no-incluida-cor-laranja/p/MLB34134740?pdp_filters=item_id%3AMLB4724706796&pdp_filters=seller_id%3A53613158#polycard_client%3Drecommendations_recoview-selleritems-eshops%26reco_backend%3Dsame-seller-odin%26wid%3DMLB4724706796%26reco_client%3Drecoview-selleritems-eshops%26reco_item_pos%3D4%26reco_backend_type%3Dlow_level%26reco_id%3Dff4d212a-7407-42e3-b9e9-9a7dab517418%26sid%3Drecos%26tracking_id%3D92c27b04-5fe8-4d4a-9a04-65511f5466c7%26source%3Deshops%26seller_id%3D53613158%26category_id%3DMLB269935"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white p-6 rounded-lg shadow-lg text-center product-card hover:bg-husqvarna-light-gray transition cursor-pointer block"
                    >
                        <img src="/images/imgmotosserrabat.jpeg" alt="Motosserra a Bateria Husqvarna" className="w-full h-48 object-contain mb-4 rounded-md" />
                        <h4 className="text-xl font-semibold mb-2 text-husqvarna-dark-gray">Motosserra a Bateria Husqvarna</h4>
                        <p className="text-md text-gray-600 mb-4">Potência e silêncio para suas tarefas de corte.</p>
                        <span className="inline-block bg-green-500 text-white text-sm px-3 py-1 rounded-full">Eco-friendly</span>
                    </a>
                    {/* Produto 3 */}
                    <a
                        href="https://produto.mercadolivre.com.br/MLB-5483937460-rocadeira-a-bateria-535irx-husqvarna-_JM"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-white p-6 rounded-lg shadow-lg text-center product-card hover:bg-husqvarna-light-gray transition cursor-pointer block"
                    >
                        <img src="/images/imgrocadeirabat.jpeg" alt="Roçadeira a Bateria Husqvarna" className="w-full h-48 object-contain mb-4 rounded-md" />
                        <h4 className="text-xl font-semibold mb-2 text-husqvarna-dark-gray">Roçadeira a Bateria</h4>
                        <p className="text-md text-gray-600 mb-4">Leve, ergonômico e sem emissões para seu jardim.</p>
                        <span className="inline-block bg-green-500 text-white text-sm px-3 py-1 rounded-full">Limpo</span>
                    </a>
                </div>
            </div>
        </section>
    );
};

// Componente Contato
const Contact = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        if (sectionRef.current) {
            gsap.fromTo(sectionRef.current.querySelector('.contact-form-left'),
                { opacity: 0, x: -50 },
                {
                    opacity: 1, x: 0, duration: 1, ease: "power3.out",
                    scrollTrigger: {
                        trigger: sectionRef.current,
                        start: "top 80%",
                        toggleActions: "play none none none"
                    }
                }
            );
            gsap.fromTo(sectionRef.current.querySelector('.contact-info-right'),
                { opacity: 0, x: 50 },
                {
                    opacity: 1, x: 0, duration: 1, ease: "power3.out",
                    scrollTrigger: {
                        trigger: sectionRef.current,
                        start: "top 80%",
                        toggleActions: "play none none none"
                    }
                }
            );
        }
    }, []);

    return (
        <section ref={sectionRef} id="contato" className="py-16">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold text-center mb-12 text-husqvarna-dark-gray animate-fade-in-up">Entre em Contato</h2>
                <div className="flex flex-col md:flex-row md:space-x-8">
                    {/* Formulário de Contato */}
                    <div className="md:w-1/2 mb-8 md:mb-0 contact-form-left">
                        <h3 className="text-2xl font-semibold mb-6 text-husqvarna-dark-gray">Envie-nos uma Mensagem</h3>
                        {/* Ação do formulário para FormSubmit.co - Substitua 'your-email@example.com' pelo seu e-mail real */}
                        <form action="https://formsubmit.co/contato@3emaquinas.com.br" method="POST" className="space-y-4 bg-white p-8 rounded-lg shadow-lg">
                            <input type="hidden" name="_captcha" value="false" /> {/* Desabilita o captcha do FormSubmit */}
                            <input type="hidden" name="_subject" value="Nova Mensagem do Site 3E Máquinas" />

                            <div>
                                <label htmlFor="name" className="block text-lg font-medium text-gray-700 mb-2">Nome Completo</label>
                                <input type="text" id="name" name="name" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-husqvarna-orange" />
                            </div>
                            <div>
                                <label htmlFor="email" className="block text-lg font-medium text-gray-700 mb-2">Seu E-mail</label>
                                <input type="email" id="email" name="email" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-husqvarna-orange" />
                            </div>
                            <div>
                                <label htmlFor="phone" className="block text-lg font-medium text-gray-700 mb-2">Telefone (Opcional)</label>
                                <input type="tel" id="phone" name="phone" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-husqvarna-orange" />
                            </div>
                            <div>
                                <label htmlFor="message" className="block text-lg font-medium text-gray-700 mb-2">Sua Mensagem</label>
                                <textarea id="message" name="message" rows="5" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-husqvarna-orange"></textarea>
                            </div>
                            <button type="submit" className="w-full bg-husqvarna-orange text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-orange-700 transition-colors duration-300 shadow-md">Enviar Mensagem</button>
                        </form>
                    </div>

                    {/* Informações de Contato e Mapa */}
                    <div className="md:w-1/2 contact-info-right">
                        <h3 className="text-2xl font-semibold mb-6 text-husqvarna-dark-gray">Nossos Dados</h3>
                        <div className="bg-white p-8 rounded-lg shadow-lg space-y-4">
                            <p className="text-lg"><i className="fas fa-map-marker-alt text-husqvarna-orange mr-3"></i> <strong>Endereço:</strong> Rua Tucuruví Nº 23 - Centro - Peruíbe-SP</p>
                            <p className="text-lg"><i className="fas fa-id-card text-husqvarna-orange mr-3"></i> <strong>CNPJ:</strong> 03970018/0001-04</p>
                            <p className="text-lg"><i className="fas fa-envelope text-husqvarna-orange mr-3"></i> <strong>CEP:</strong> 11770-120</p>
                            <p className="text-lg"><i className="fas fa-phone-alt text-husqvarna-orange mr-3"></i> <strong>Telefone:</strong> +55 13 3455-3572</p>
                            <p className="text-lg"><i className="fab fa-whatsapp text-husqvarna-orange mr-3"></i> <strong>WhatsApp:</strong> <a href="https://wa.me/551334553572" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">13 34553572</a></p>
                            <p className="text-lg"><i className="fas fa-envelope text-husqvarna-orange mr-3"></i> <strong>E-mail:</strong></p>
                            <ul className="list-disc pl-8 text-lg">
                                <li>Treinamentos: <a href="mailto:treinamentos@3emaquinas.com.br" className="text-blue-600 hover:underline">treinamentos@3emaquinas.com.br</a></li>
                                <li>Perícia: <a href="mailto:perito@3emaquinas.com.br" className="text-blue-600 hover:underline">perito@3emaquinas.com.br</a></li>
                                <li>Licitações: <a href="mailto:lic@3emaquinas.com.br" className="text-blue-600 hover:underline">lic@3emaquinas.com.br</a></li>
                                <li>Atendimento: <a href="mailto:atendimento@3emaquinas.com.br" className="text-blue-600 hover:underline">atendimento@3emaquinas.com.br</a></li>
                            </ul>
                        </div>
                        <div className="mt-8 rounded-lg shadow-lg overflow-hidden">
                            {/* Mapa do Google Maps - Substitua o src pelo seu próprio embed map */}
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3648.749508688849!2d-47.039600184999995!3d-24.20888998436578!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94d1e2e2e2e2e2e2%3A0x8e2e2e2e2e2e2e2e!2sRua%20Tucuruv%C3%AD%2C%2023%20-%20Centro%2C%20Perui%CC%88be%20-%20SP%2C%2011770-120%2C%20Brasil!5e0!3m2!1spt-BR!2sus!4v1678901234567!5m2!1spt-BR!2sus"
                                width="100%"
                                height="350"
                                title="Mapa da 3E Máquinas"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                className="rounded-lg"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

// Componente Footer
const Footer = () => {
    return (
        <footer className="bg-husqvarna-dark-gray text-husqvarna-white py-8 text-center">
            <div className="container mx-auto px-4">
                <p>&copy; 2025 3E Máquinas. Todos os direitos reservados.</p>
                <div className="mt-4 text-sm">
                    <p><strong>Endereço:</strong> Rua Tucuruví Nº 23 - Centro - Peruíbe-SP - CEP: 11770-120</p>
                    <p><strong>CNPJ:</strong> 03970018/0001-04</p>
                    <p><strong>Telefone:</strong> +55 13 3455-3572 | <strong>WhatsApp:</strong> 13 34553572</p>
                    <p><strong>E-mails:</strong> treinamentos@3emaquinas.com.br | perito@3emaquinas.com.br | lic@3emaquinas.com.br | atendimento@3emaquinas.com.br</p>
                </div>
            </div>
        </footer>
    );
};

// Componente que agrupa as seções da página inicial
const HomePage = () => {
    const location = useLocation();

    // Efeito para rolar para a seção correta ao navegar de outra página
    useEffect(() => {
        const { scrollTo } = location.state || {};
        if (scrollTo) {
            const section = document.getElementById(scrollTo);
            if (section) {
                // Timeout para garantir que a página foi renderizada antes da rolagem
                setTimeout(() => {
                    section.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        }
    }, [location]);

    return (
        <>
            <HeroSection />
            <ServicesSection />
            <MercadoLivreSection />
            <HusqvarnaProducts />
            <Contact />
        </>
    );
};

// Componente principal da aplicação React
const App = () => (
    <Router>
        <div className="font-inter text-husqvarna-dark-gray">
            {/* Navbar é sempre visível */}
            <Navbar />

            {/* Main content com um padding-top para compensar a navbar fixa */}
            <main className="pt-16">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/pericia" element={<Pericia />} />
                    <Route path="/mercado-livre" element={<MercadoLivre />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/husqvarna" element={<Husqvarna />} />
                    <Route path="/treinamento" element={<Treinamento />} />
                    <Route path="/services" element={<Services />} />
                    {/* Redireciona qualquer rota não reconhecida para a página inicial */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </main>
            {/* Footer é sempre visível */}
            <Footer />
        </div>
    </Router>
);

export default App;
